<div class="rollup-tabs-content w-100">
  <div class="mb-3">
    <app-checked-and-held-items-banner-container
      [recordIds]="materialTab.recordIds"
      [hasEcontentIssues]="hasEcontentIssues"
      [instanceIds]="instanceIds"
      [vendors]="materialTab?.availability?.vendors">
    </app-checked-and-held-items-banner-container>
  </div>
  <div class="row justify-content-end">
    <div class="col-12 col-md">

      <ng-template #physicalItemTmpl>
        <app-physical-item-availability [materialTab]="materialTab"
                                        [availabilityStatus]="availabilityUpdateInfo?.status?.general">
        </app-physical-item-availability>
      </ng-template>

      <div class="row mb-3" *ngIf="this.materialTab.holdingsLatestReceived">
        <div class="col-auto rollup-tabs-content-card-col-mw-fixed">
          {{'latestReceived' | translate}}
        </div>
        <div class="w-100 d-lg-none"></div>
        <div class="col" data-automation-id="latest-received">
          <p class="mb-1">{{this.materialTab.holdingsLatestReceived}}</p>
        </div>
      </div>

      <div class="mb-3"
           *ngIf="materialTab.holdingsDisplayStrings?.length || materialTab.indexesDisplayStrings?.length > 0
           || materialTab.supplementsDisplayStrings?.length > 0">
        <app-library-has
          [issuesStrings]="materialTab.holdingsDisplayStrings"
          [supplementsStrings]="materialTab.supplementsDisplayStrings"
          [indexesStrings]="materialTab.indexesDisplayStrings"
        ></app-library-has>
      </div>
    </div>

    <div class="col-auto tabs-btn flex-column">
          <button
            class="ins-buttons no-border button-primary flint w-100"
            data-automation-id="place-hold-btn"
            translate
            (click)="onGetIt($event)"
            [attr.aria-describedby]="'get-offers-button'"
          >
            {{'request' | translate}}
          </button>
    </div>
  </div>

  <!-- Edition info SRP -->
  <div class="d-flex mt-8 mt-md-0">
    <a (click)="onLocationAndEditionInfoClick()"
       data-automation-id="loc-and-edtn-info"
       class="location-link"
       [attr.aria-label]="'editionInformationForTitle' | translate : {title: fgTitle}"
    >{{'viewLocationAndEditionInfoBtn' | translate}}</a>
  </div>
</div>
